<template>
  <div class="sale-query">
    <el-form ref="form" :model="form" inline class="table-search-bar" label-width="80px">
      <el-form-item label="开票单位" prop="deptName">
        <el-input v-model="form.deptName" placeholder="请输入开票单位"></el-input>
      </el-form-item>
      <!-- <el-form-item label="开单人" prop="invoicePerson">
        <el-input v-model="form.invoicePerson" placeholder="请输入开单人"></el-input>
      </el-form-item> -->
      <el-form-item label="产品名称" prop="itemName">
        <el-input v-model="form.itemName" placeholder="请输入产品名称"></el-input>
      </el-form-item>
      <!-- <el-form-item label="客户名称" prop="consumerName">
        <el-input v-model="form.consumerName" placeholder="请输入客户名称"></el-input>
      </el-form-item> -->
      <el-form-item label="提货单号" prop="takeOrderNo">
        <el-input v-model="form.takeOrderNo" placeholder="请输入提货单号"></el-input>
      </el-form-item>
      <!-- <el-form-item label="发货地" prop="areaId">
        <ajax-select v-model="form.areaId" type="areaNoLocalArea"></ajax-select>
      </el-form-item>
      <el-form-item label="协议类型" prop="agreementType">
        <el-select v-model="form.agreementType" placeholder="请选择">
          <el-option
            v-for="item in typeArr"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="调拨类型" prop="preferentialType">
        <el-select v-model="form.preferentialType" placeholder="请选择">
          <el-option
            v-for="item in preferentialTypeArray"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item> -->
      <!--<el-form-item label="订单类型" prop="orderType">
        <el-select v-model="form.orderType" placeholder="请输入订单类型">
          <el-option
            v-for="item in typeArr"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>-->
      <!--<el-form-item label="订单状态" prop="orderType">-->
        <!--<el-select v-model="form.orderStatusFlag" placeholder="请输入订单类型">-->
          <!--<el-option-->
            <!--v-for="item in orderStatusArr"-->
            <!--:key="item.value"-->
            <!--:label="item.label"-->
            <!--:value="item.value">-->
          <!--</el-option>-->
        <!--</el-select>-->
      <!--</el-form-item>-->
      <!-- <el-form-item label="协议状态" prop="auditStatus">
        <el-select v-model="form.auditStatus">
          <el-option
            v-for="item in auditStatus"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="车牌号" prop="plateNum">
        <el-input v-model="form.plateNum" placeholder="请输入车牌号"></el-input>
      </el-form-item>
      <el-form-item label="协议单号" prop="code">
        <el-input v-model="form.code" placeholder="请输入协议单号"></el-input>
      </el-form-item>
      <!-- <el-form-item label="销售人员" prop="initiatorName">
        <el-input v-model="form.initiatorName" placeholder="请输入销售人员"></el-input>
      </el-form-item> -->
      <!--<el-form-item label="订单编号" prop="orderNum">
        <el-input v-model="form.orderNum" placeholder="请输入订单编号"></el-input>
      </el-form-item>-->
      <!-- <el-form-item label="省市" prop="citis">
        <multi-cascader
          v-model="form.citis"
          :data="citisOptions"
          clearable
          ref="citisSelector"></multi-cascader>
      </el-form-item> -->
      <el-form-item label="运单号" prop="waybillNumber">
        <el-input v-model="form.waybillNumber" placeholder="请输入运单号"></el-input>
      </el-form-item>
      <!-- <el-form-item label="开单时间" prop="invoiceTime">
        <el-date-picker
          v-model="form.invoiceTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          :defaultTime="['00:00:00', '23:59:59']">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="结算时间" prop="createTime">
        <el-date-picker
          v-model="form.createTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          :defaultTime="['00:00:00', '23:59:59']">
        </el-date-picker>
      </el-form-item> -->
      <el-form-item label="过毛时间" prop="tareWeightTime">
        <el-date-picker
          popper-class="picktime-box"
          v-model="form.tareWeightTime"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
          :defaultTime="['00:00:00', '23:59:59']"
          :clearable="false">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleSearch">搜索</el-button>
        <el-button type="primary" @click="handleReset">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="list"
      style="width: 100%"
      tooltip-effect="light"
      ref="multipleTable">
      <el-table-column
        prop="deptName"
        label="开票单位"
        show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column
        prop="consumerName"
        label="客户名称"
        show-overflow-tooltip>
      </el-table-column> -->
      <!--<el-table-column
        prop="orderNum"
        label="订单编号"
        show-overflow-tooltip>
      </el-table-column>-->
      <!-- <el-table-column
        prop="terminal"
        label="终端来源"
        show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column
        prop="takeOrderNo"
        label="销售提货单号"
        show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column
        prop="provinceName"
        label="省份"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="cityName"
        label="地市"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="areaName"
        label="发货地"
        show-overflow-tooltip>
      </el-table-column>
       <el-table-column
        prop="areaNameOrg"
        align="center"
        label="发货地组织"
        show-overflow-tooltip>
      </el-table-column> -->
      <!-- <el-table-column
        prop="orderType"
        label="协议类型"
        :formatter="orderTypeFormat"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="preferentialTypeStr"
        label="调拨类型"
        show-overflow-tooltip>
      </el-table-column> -->
      <!--<el-table-column
        prop="orderType"
        label="订单类型"
        :formatter="orderTypeFormat"
        show-overflow-tooltip>
      </el-table-column>-->
      <el-table-column
        prop="code"
        label="协议单号"
        show-overflow-tooltip>
      </el-table-column>
      <!--<el-table-column
        prop="preferentialTypeDesc"
        label="协议优惠"
        show-overflow-tooltip>
      </el-table-column>-->
      <!-- <el-table-column
        prop="agreeCode"
        label="合同号"
        show-overflow-tooltip>
      </el-table-column> -->
      <!--<el-table-column
        prop="orderTime"
        label="订购日期"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="itemListingPrice"
        label="订购日单价"
        show-overflow-tooltip>
      </el-table-column>-->
      <el-table-column
        prop="logisticsMode"
        label="提货方式"
        :formatter="logisticsModeFormat"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="plateNum"
        label="车牌号"
        show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column
        prop="deliveryAddress"
        label="目的地"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="deliveryAddressOrg"
        label="目的地组织"
        align="center"
        show-overflow-tooltip>
      </el-table-column> -->
      <!-- <el-table-column
        prop="itemCode"
        label="产品编号"
        show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column
        prop="itemName"
        label="产品名称"
        show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column
        prop="uomCode"
        label="计量单位"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="preTakeCount"
        label="订购数量"
        show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column
        prop="netSend"
        label="发运数量"
        show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column
        prop="netReceipts"
        label="实收"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="settlementBasisStr"
        label="结算依据"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="itemDiscountedPrice"
        label="执行单价"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="freightPayAmount"
        label="运费"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="craneName"
        label="鹤位"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="tareWeight"
        label="皮重"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="grossWeight"
        label="毛重"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="actualNum"
        label="净重"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="impurity"
        label="杂质"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="payAmount"
        label="总金额"
        show-overflow-tooltip>
      </el-table-column> -->
      <!-- <el-table-column
        prop="itemPayAmount"
        label="净额"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="invoicePerson"
        label="开单人"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="initiatorName"
        label="销售人员"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="invoiceTime"
        label="开单时间"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="itemListingPriceCur"
        label="开单日单价"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="weightNo"
        label="过磅单号"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="tareWeightTime"
        label="过皮时间"
        show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column
        prop="tareWeightTime"
        label="过毛时间"
        show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column
        prop="accountTime"
        label="结算时间"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="weightPerson"
        label="司磅员"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="accountor"
        label="结算人"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="remake"
        label="备注"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="takeOrderRemark"
        label="车辆备注信息"
        show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column
        prop="waybillNumber"
        label="运单号"
        show-overflow-tooltip>
      </el-table-column>
      <el-table-column
        prop="unloadNumber"
        label="卸车数"
        show-overflow-tooltip>
      </el-table-column>
       <el-table-column
        prop="shortfall"
        label="亏吨数"
        show-overflow-tooltip>
      </el-table-column>
      <!--<el-table-column
        prop="benefitMode"
        label="优惠方案"
        show-overflow-tooltip>
      </el-table-column>-->
    </el-table>
    <div>
      <el-pagination
        :page-sizes="[10, 20, 50, 100]"
        :page-size="listState.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="listState.total"
        :current-page="listState.pageNo"
        background
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange">
      </el-pagination>
      <div class="output-box" v-permission="'0171701'">
        每页<el-select class="select-page" v-model="form.pageSize" placeholder="请选择条数">
          <el-option
            v-for="item in sizeArr"
            :key="item.value"
            :label="item.label"
            :value="item.label">
          </el-option>
        </el-select>条
        第<el-select class="select-page" v-model="form.pageNo" placeholder="请输入页码">
          <el-option
            v-for="item in sizeNumber"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>页
        <!-- 第<el-input class="input-page" type="number" v-model="form.pageNo" placeholder="请输入页码"></el-input>页 -->
        <el-button class="select-page-btn" type="primary" @click="handleExport()" v-permission="'0171702'">导出为CSV文件</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { formatTime } from '../../../common/utils'
import AjaxSelect from '../../../components/ajaxSelect/index'
import MultiCascader from '../../../components/multiCascader/multi-cascader-base-element/multiCascader'

export default {
  name: 'saleQuery',
  components: { AjaxSelect, MultiCascader },
  data () {
    return {
      form: {
        deptName: '',
        agreementType: '',
        preferentialType: '',
        consumerName: '',
        orderType: '',
        // orderStatusFlag: 2,
        itemName: '',
        createTime: '',
        takeOrderNo: '',
        areaId: '',
        plateNum: '',
        invoiceTime: '',
        orderTime: '',
        invoicePerson: '',
        code: '',
        initiatorName: '',
        orderNum: '',
        auditStatus: '',
        citis: [],
        pageNo: 1,
        pageSize: 20000,
        tareWeightTime: [formatTime(new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1), true), formatTime(new Date(), true)],
        isCheckRecord: '',
        logisticsMode: -1
      },
      // 协议类型
      typeArr: [
        {
          value: '',
          label: '全部'
        },
        {
          value: 10,
          label: '调拨协议'
        },
        {
          value: 11,
          label: '涮罐协议'
        },
        {
          value: 12,
          label: '置换管线协议'
        }
      ],
      preferentialTypeArray: [
        {
          value: '',
          label: '全部'
        },
        {
          value: 1,
          label: '正常调拨'
        },
        {
          value: 2,
          label: 'SAP调拨'
        }
      ],
      sizeArr: [
        { value: '', label: '1000' },
        { value: 1, label: '5000' },
        { value: 2, label: '10000' },
        { value: 3, label: '20000' }
      ],
      // 订单状态
      orderStatusArr: [
        { value: '', label: '全部' },
        { value: 1, label: '已完成' },
        { value: 2, label: '未完成' }
      ],
      // 协议状态
      auditStatus: [
        { value: '', label: '全部' },
        { value: 0, label: '不需要审核' },
        { value: 1, label: '待审核' },
        { value: 2, label: '审核被驳回' },
        { value: 3, label: '审核通过' },
        { value: 4, label: '已撤销' },
        { value: 5, label: '变更中' }
      ],
      citisOptions: []
    }
  },
  computed: {
    ...mapGetters({ list: 'getTransferSaleList', listState: 'getTransferSaleListState' }),
    sizeNumber () {
      const maxNo = Math.ceil(this.listState.total / this.form.pageSize) + 1
      const newArr = [...new Array(maxNo).keys()]
      newArr.shift()
      return newArr
    }
  },
  methods: {
    ...mapActions(['getTransferSaleList', 'exportTransferSale', 'getCityInfo']),
    // 搜索
    handleSearch () {
      this.getTransferSaleList({ ...this.form, pageNo: 1, pageSize: 10 })
    },
    // 分页条数变更
    handleSizeChange (val) {
      this.getTransferSaleList({ pageSize: val, pageNo: 1 })
    },
    // 分页跳转
    handleCurrentChange (val) {
      this.getTransferSaleList({ pageNo: val })
    },
    // 查询表单，表格重置
    handleReset () {
      this.form.pageNo = 1
      this.form.pageSize = 20000
      this.$refs['form'].resetFields()
      // this.$refs['citisSelector'].reset()
      this.handleSearch()
    },
    // 导出
    handleExport () {
      if (!Array.isArray(this.list) || this.list.length === 0) {
        this.$message({
          message: '暂无数据',
          type: 'warning'
        })
        return
      }
      this.$confirm('是否确认导出', '导出', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(() => {
        this.exportTransferSale({ ...this.form }).then((res) => {
          function createDownloadFile () {
            let blobObject = new Blob([res])
            let fileName = '调拨销售查询报表.xls'
            // 兼容 IE系列 浏览器
            if (window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(blobObject, fileName)
            } else {
              let link = document.createElement('a')
              link.download = fileName
              link.style.display = 'none'
              link.target = '_Blank'
              link.href = window.URL.createObjectURL(blobObject)
              console.log(link)
              document.body.appendChild(link)
              link.click()
              window.URL.revokeObjectURL(link.href)
            }
          }
          createDownloadFile()
          this.$message.success('导出成功')
          this.form.pageNo = 1
          this.form.pageSize = 20000
        })
      })
        .catch(() => {
        })
    },
    initCitis () {
      this.getCityInfo().then(res => {
        this.citisOptions = res.map(item => {
          const { children, ...info } = item
          const newChildren = item.children.map(city => {
            const { children, ...info } = city
            return {
              value: city.id,
              label: city.name,
              ...info
            }
          })
          return {
            children: newChildren,
            value: item.id,
            label: item.name,
            ...info
          }
        })
      })
    },
    orderTypeFormat (row) {
      switch (row.agreementType) {
        case 10:
          return '调拨'
        case 11:
          return '涮罐'
        case 12:
          return '置换管线'
        default:
          break
      }
    },
    logisticsModeFormat (row) {
      switch (row.logisticsMode) {
        case 1:
          return '自提'
        case 2:
          return '京博物流'
        case 11:
          return '配送'
        case 12:
          return '港口配送'
        default:
          break
      }
    }
  },
  mounted () {
    this.form.isCheckRecord = ''
    this.form.orderTime = ''
    this.form.invoiceTime = ''
    this.form.createTime = ''
    this.initCitis()
    this.handleSearch()
  }
}
</script>

<style lang="scss">
.output-box{
margin-top: 20px;
text-align: right;
}
.input-page, .select-page{
  width: 98px;
  margin: 0 15px;
}
.input-page, .select-page-btn{
  width: 120px;
  margin: 0 15px;
}
.picktime-box .el-button--text{
  display: none;
}
</style>
